'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformInput = exports.tcnp = exports.tcp = exports.tcn = exports.tc = exports.tnp = exports.tp = exports.tn = exports.t = exports.locale = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locale = exports.locale = _propTypes2.default.string;
var t = exports.t = _propTypes2.default.func;
var tn = exports.tn = _propTypes2.default.func;
var tp = exports.tp = _propTypes2.default.func;
var tnp = exports.tnp = _propTypes2.default.func;
var tc = exports.tc = _propTypes2.default.func;
var tcn = exports.tcn = _propTypes2.default.func;
var tcp = exports.tcp = _propTypes2.default.func;
var tcnp = exports.tcnp = _propTypes2.default.func;
var transformInput = exports.transformInput = _propTypes2.default.func;